module.exports = __webpack_public_path__ + "static/game3-4ed2ef23c37b9a7bd1c4508ecf2a280a.gif";